import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import { bucket_url } from '../../constants/const'
import Loading from '../../components/layouts/Loading'
import { useLocation } from 'react-router-dom';
import queryString from 'query-string'
import { Container, Row, Col, Nav, Pagination, Form } from "react-bootstrap";
import PageHeader from "../../components/pageHeader/pageHeader.component";
import ExamCard from "../../components/examCard/examCard.component";

import '../../assets/globalCss/courses.global.css';
import ExamsStyles from './exams.module.css';

import ExamsPageCover from '../../assets/images/banners/exams.png';

const ExamsPage = props => {

    const location = useLocation()

    const [cat, setCat] = useState({})

    useEffect(() => {
        setCat(queryString.parse(location.search))
    }, [location])

    const { loading, webExam } = useSelector(state => state.all)

    const [allExams, setAllExams] = useState()

    const [currentFilter, setCurrentFilter] = useState('all')

    useEffect(() => {
        setAllExams(webExam)
    }, [webExam])

    const handleFilter = (type, value) => {
        setCat({ category: 'all' })
        if (type === 'all') {
            setAllExams(webExam)
            setCurrentFilter(type)
        }
        if (type === 'free') {
            setAllExams(webExam.filter(item => item.price === 0))
            setCurrentFilter(type)
        }
        if (type === 'paid') {
            setAllExams(webExam.filter(item => item.price !== 0))
            setCurrentFilter(type)
        }
    }

    useEffect(() => {
        if (cat.category && webExam && webExam.length > 0) {
            handleCategoryFilter(cat.category)
        }
    }, [webExam])

    const handleCategoryFilter = value => {
        if (currentFilter === 'all') {
            if (value === 'all') {
                setAllExams(webExam)
            } else {
                setAllExams(webExam.filter(item => item.categories[0] === value))
            }
        }

        if (currentFilter === 'paid') {
            if (value === 'all') {
                setAllExams(webExam.filter(item => item.price !== 0))
            } else {
                setAllExams(webExam.filter(item => item.price !== 0 && item.categories[0] === value))
            }
        }

        if (currentFilter === 'free') {
            if (value === 'all') {
                setAllExams(webExam.filter(item => item.price === 0))
            } else {
                setAllExams(webExam.filter(item => item.price === 0 && item.categories[0] === value))
            }

        }
    }



    let active = 2;
    let items = [
        <Pagination.First>First</Pagination.First>,
        <Pagination.Prev>Prev</Pagination.Prev>
    ];
    for (let number = 1; number <= 5; number++) {
        items.push(
            <Pagination.Item key={number} active={number === active}>
                {number}
            </Pagination.Item>,
        );
    }
    items.push(<Pagination.Next>Next</Pagination.Next>);
    items.push(<Pagination.Last>Last</Pagination.Last>);

    return (
        <div>
            <PageHeader
                title="আমাদের ই-এক্সামসমূহ"
                cover={ExamsPageCover}
            >
                <p>
                    কঠিন বিষয়গুলো সহজে মনে রাখা জন্য Tricks শেখানো হয়। একইসাথে অধিক গুরুত্বপূর্ণ অংশগুলো চিহ্নিত করতে লাল
                    সবুজ কালিতে বই দাগানো হয়ে থাকে।
                </p>
            </PageHeader>

            <section className="course-nav-section">
                <Container>
                    <Row>
                        <Col xs={12} lg={6}>
                            <Nav className="courses-nav justify-content-center justify-content-lg-start mt-2 mt-lg-0 mb-2 mb-lg-0" defaultActiveKey="/courses" as="ul">
                                <Nav.Item as="li">
                                    <Nav.Link href="#" className={currentFilter === 'all' ? 'active' : ''} onClick={() => handleFilter('all')}>All</Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                    <Nav.Link href="###" onClick={() => handleFilter('free')}>Free</Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                    <Nav.Link href="##" onClick={() => handleFilter('paid')}>Paid</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                        <Col xs={12} lg={6} className="align-self-center">
                            <Nav className="courses-nav justify-content-center justify-content-lg-end mt-2 mt-lg-0 mb-2 mb-lg-0">
                                <Nav.Item as="li">
                                    <Form>
                                        <Form.Control as="select" onChange={(e) => { handleCategoryFilter(e.target.value); }}>
                                            <option disabled={true}>Select</option>
                                            <option value="all" selected={cat.category === 'all'}>All</option>
                                            <option value="academic" selected={cat.category === 'academic'}>Academic</option>
                                            <option value="admission" selected={cat.category === 'admission'}>Admission</option>
                                        </Form.Control>
                                    </Form>
                                </Nav.Item>
                            </Nav>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section styleName="ExamsStyles.exams-list-section">
                <Container>
                    <Row>
                        {loading ? <Loading /> : (
                            allExams && allExams.map(item => {
                                if (item.status === 'show')
                                    return <Col className="mb-4" xs={12} lg={4}>
                                        <ExamCard
                                            link={`/exams/${item.title.replace(/ /g, "-")}/${item._id}`}
                                            price={item.price}
                                            discount={item.discount}
                                            banner={`${bucket_url}${item.coverPhoto}`}
                                            title={item.title}
                                            subTitle={item.excerpt}
                                        />
                                    </Col>
                            })
                        )}
                    </Row>
                    {/* <Row>

                        <Col className="mb-4" xs={12} lg={4}>
                            <ExamCard
                                link={"/courses/course-id-" + i}
                                price="১৫০০০ টাকা"
                                discounted={(i % 2 == 0) ? "১২০০০ টাকা" : null}
                                banner={"https://picsum.photos/530/280?random=" + i}
                                title="মেডিকেল ভর্তি পরীক্ষা প্রস্তুতি"
                                subTitle="প্রথম পর্যায়ে প্রতি সপ্তাহে চারদিন ক্লাস হবে; প্রতিটি ২ ঘন্টা ৩০ মিনিট করে।
                                                    প্রথম ২৫ মিনিট পূর্ববর্তী লেকচারের উপর ৫০ নম্বরের MCQ পরীক্ষা হবে।"
                            />
                        </Col>

                    </Row> */}
                    { }
                    {/* <Row className="mt-3">
                        <Col xs={12}>
                            <Pagination className="courses-pagination justify-content-center flex-wrap">{items}</Pagination>
                        </Col>
                    </Row> */}
                </Container>
            </section>

        </div>
    )
}

export default ExamsPage;


